module.exports = __webpack_public_path__ + "assets/img/spirte.png?4c08ce3e0b8f93a9ea8811b8b5aa5070";